import React from "react";
import InitialsAvatar from "../../InitialsAvatar";
import "./style.css";

const GenericStatCard = ({
  title,
  value,
  percentage,
  isIncrease = true,
  subtitle,
  icon,
  status,
  showBlankLine = false,
  profileImage,
  profileLabel,
  profileName,
}) => {
  return (
    <div className="stat-card">
      <div className="stat-header">
        <div className="title">{title}</div>

        {icon && (
          <span className="stat-icon">
            {typeof icon === "string" ? <img src={icon} alt="icon" /> : icon}
          </span>
        )}
      </div>
      <div className="stat-body">
        {profileName ? (
          <div className="profile-container">
            <InitialsAvatar
              src={profileImage}
              name={profileName}
              alt="profile"
              className="avatar"
              style={{ fontSize: 14 }}
            />
            <div className="profile-text">
              <div className="profile-label">{profileLabel}</div>
              <div className="profile-name">{profileName}</div>
            </div>
          </div>
        ) : (
          <>
            {status ? (
              <div className="status">{status}</div>
            ) : (
              <div
                className={`value ${
                  typeof value === "number"
                    ? value < 0
                      ? "negative"
                      : ""
                    : String(value).includes("-")
                      ? "negative"
                      : ""
                }`}
              >
                {value}
              </div>
            )}

            {percentage !== undefined && (
              <div className={`badge ${isIncrease ? "up" : "down"}`}>
                {isIncrease ? "▲" : "▼"} {percentage}
              </div>
            )}
          </>
        )}
      </div>

      {(subtitle || showBlankLine) && (
        <p className="subtitle">
          {subtitle ? subtitle : showBlankLine ? "\u00A0" : null}
        </p>
      )}
    </div>
  );
};

export default GenericStatCard;
